import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['select'];

  static values = {
    initial: String
  };

  static classes = ['defaultOption', 'selectedOption'];

  // TARGETS
  declare selectTarget: HTMLSelectElement;

  // VALUES
  declare initialValue: string;

  // CLASSES
  declare selectedOptionClass: string;
  declare defaultOptionClass: string;

  handleChange(e) {
    const isDefaultOption = e.target.value == this.initialValue;

    if (isDefaultOption) {
      this.applyDefaultOptionStylingClass();
    } else {
      this.applySelectedOptionStylingClass();
    }
  }

  applyDefaultOptionStylingClass() {
    this.selectTarget.classList.add(this.selectedOptionClass);
    this.selectTarget.classList.remove(this.defaultOptionClass);
  }

  applySelectedOptionStylingClass() {
    this.selectTarget.classList.remove(this.selectedOptionClass);
    this.selectTarget.classList.add(this.defaultOptionClass);
  }
}
